import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Pusher from 'pusher-js'; // Import Pusher

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch notifications from the API
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.post(
          'https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/get-notifications',
          {
            token: token,
          }
        );

        // Set notifications from the API response
        setNotifications(response.data.notifications.notifications);
        // Save to local storage
        localStorage.setItem('notifications', JSON.stringify(response.data.notifications.notifications));
      } catch (err) {
        setError('Failed to fetch notifications');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  // Load notifications from local storage if API fails
  useEffect(() => {
    const savedNotifications = JSON.parse(localStorage.getItem('notifications')) || [];
    if (savedNotifications.length > 0) {
      setNotifications(savedNotifications);
    }
  }, []);

  // Pusher integration for real-time notifications
  useEffect(() => {
    const userEmail = localStorage.getItem('email'); // Assuming you store the user's email in localStorage
    if (!userEmail) {
      console.error('User email not found');
      return;
    }

    // Initialize Pusher
    const pusher = new Pusher('e9cffd90dff19b3b8976', {
      cluster: 'ap2',
    });

    // Sanitize the email to use as a channel name
    const channel = pusher.subscribe(userEmail);

    // Listen for new notifications
    channel.bind('new-notification', (data) => {
      console.log(data);
      const { notification } = data; // Destructure the notification object

      if (!notification || !notification.message || !notification.createdAt) {
        console.error('Received notification is missing required fields');
        return;
      }

      // Update state with the new notification
      setNotifications((prevNotifications) => [
        {
          message: notification.message,
          isRead: false, // Mark as unread
          createdAt: notification.createdAt,
        },
        ...prevNotifications, // Add to the top of the list
      ]);

      // Save to local storage
      const updatedNotifications = [
        {
          message: notification.message,
          isRead: false,
          createdAt: notification.createdAt,
        },
        ...notifications,
      ];
      localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
    });

    // Cleanup Pusher connection on unmount
    return () => {
      pusher.unsubscribe(userEmail);
      pusher.disconnect();
    };
  }, [notifications]);

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (error) {
    return <div className="flex justify-center items-center h-screen text-red-500">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Notifications</h1>
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        {notifications.length > 0 ? (
          // Reverse the notifications array before mapping
          [...notifications].reverse().map((notification, index) => (
            <div
              key={index}
              className="p-4 mb-4 bg-blue-50 rounded-lg flex justify-between items-center"
            >
              <div className="flex items-center">
                {/* Blue dot for unread notifications */}
                {!notification.isRead && (
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                )}
                <span className="text-blue-800">{notification.message}</span>
              </div>
              <span className="text-sm text-gray-500">
                {new Date(notification.createdAt).toLocaleTimeString()}
              </span>
            </div>
          ))
        ) : (
          <p className="text-gray-500">No notifications found.</p>
        )}
      </div>
    </div>
  );
}

export default Notification;